import { PurchaseOrder_purchaseOrder } from 'purchaseOrder/view/__generated__/PurchaseOrder';
import { PurchaseOrderValues } from 'purchaseOrder/view/types';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { PurchaseOrderAvailableDocumentTypes } from '../__generated__/PurchaseOrderAvailableDocumentTypes';
import { AttachFormModal } from './AttachFormModal';
interface AttachFormProps {
  availableDocumentTypes: PurchaseOrderAvailableDocumentTypes | undefined;
  purchaseOrder: PurchaseOrder_purchaseOrder;
}

export const AttachForm: React.FC<AttachFormProps> = ({
  purchaseOrder,
  availableDocumentTypes,
}) => {
  const {
    formState: { isDirty },
  } = useFormContext<PurchaseOrderValues>();

  return (
    <AttachFormModal
      purchaseOrder={purchaseOrder}
      availableDocumentTypes={availableDocumentTypes}
      isDirty={isDirty}
    />
  );
};
